function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage, injectIntl } from 'react-intl';
import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { useDispatch, useSelector } from 'react-redux';
import Form from '../../../../../components/Form';
import Alert from '../../../../../components/Alert';
import * as selectors from '../../../selectors';
import * as actions from '../../../actions';
import messages from '../../../messages';
import Timepicker from './Timepicker';
import { timeIntervalsMap } from './constants';
import styles from './PatientGestationalReportParams.pcss';
const PatientGestationalReportParams = ()=>{
    const [formError, setFormError] = useState();
    const [gestationalReportParams, setGestationalReportParams] = useState([]);
    const gestationalReportSettings = useSelector(selectors.gestationalReportSettingsSelector);
    const dispatch = useDispatch();
    const centeredClass = cn(styles.gestationalReportParams__param, styles['gestationalReportParams__param--normal'], styles['gestationalReportParams__param--centered']);
    const setGestationalReportSettings = (newGestationalReportSettings)=>{
        dispatch(actions.setGestationalReportSettings(newGestationalReportSettings));
    };
    const onSetGestationalParamValue = ({ id, value })=>{
        const clonedSettings = [
            ...gestationalReportSettings
        ];
        const mealIndex = clonedSettings.findIndex((elem)=>elem.id === id);
        clonedSettings[mealIndex] = _object_spread_props(_object_spread({}, clonedSettings[mealIndex]), {
            value
        });
        const settingsByValue = clonedSettings.reduce((res, elem)=>_object_spread_props(_object_spread({}, res), {
                [elem.id]: elem
            }), {});
        /* eslint-disable camelcase */ const { night_am, breakfast, lunch, dinner, night_pm } = settingsByValue;
        const fError = ![
            night_am.value,
            breakfast.value,
            lunch.value,
            dinner.value,
            night_pm.value
        ].every((val, index, array)=>index === 0 || val >= array[index - 1]);
        setFormError(fError);
        setGestationalReportParams(clonedSettings);
    };
    const renderReportSettingsError = ()=>/*#__PURE__*/ _jsx(Alert, {
            type: "error",
            message: messages.report.errors.wrongOrder
        });
    useEffect(()=>{
        if (!formError && gestationalReportParams.length) {
            setGestationalReportSettings(gestationalReportParams);
        }
    }, [
        gestationalReportParams,
        formError
    ]);
    if (!gestationalReportSettings) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Form, {
        className: styles.gestationalReportParams,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.gestationalReportParams__row,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.gestationalReportParams__heading,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.labels.mealName))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.gestationalReportParams__heading,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.labels.mealStart))
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.gestationalReportParams__row,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.gestationalReportParams__param,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.meals.night_am))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: centeredClass,
                        children: gestationalReportSettings[0].value
                    })
                ]
            }),
            timeIntervalsMap.map(({ mealName, valueIndex })=>/*#__PURE__*/ _jsxs("div", {
                    className: styles.gestationalReportParams__row,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.gestationalReportParams__param,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.meals[mealName]))
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.gestationalReportParams__timePicker,
                            children: /*#__PURE__*/ _jsx(Timepicker, {
                                id: mealName,
                                value: gestationalReportSettings[valueIndex].value,
                                onSetValue: onSetGestationalParamValue
                            })
                        })
                    ]
                }, mealName)),
            formError && renderReportSettingsError()
        ]
    });
};
export default withStyles(styles)(injectIntl(PatientGestationalReportParams));
